// Module
var code = `<div class="jumbotron-surface schedule-inspector" ng-if="\$ctrl.draft">
  <div class="jumbotron-panel-head">
    <span class="jumbotron-heading">{{ \$ctrl.isNew ? 'New interval' : 'Interval' }}</span>
    <button type="button" class="btn-close" ng-click="\$ctrl.cancel()" aria-label="Close"></button>
  </div>
  <fieldset class="schedule-inspector-body" ng-disabled="\$ctrl.isSaving">
    <legend class="visually-hidden">The values of the interval</legend>
    <div class="schedule-inspector-field">
      <label class="jumbotron-field-label schedule-inspector-label" for="inspector-playlist-search">Playlist</label>
      <div class="input-group input-group-sm mb-2">
        <span class="input-group-text"><i class="fas fa-search" aria-hidden="true"></i></span>
        <input type="text" id="inspector-playlist-search" class="form-control" ng-model="\$ctrl.playlistSearch"
          placeholder="Search…">
        <button class="btn btn-outline-secondary" type="button" ng-show="\$ctrl.playlistSearch"
          ng-click="\$ctrl.playlistSearch = ''" aria-label="Clear search">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div class="schedule-inspector-playlists" role="listbox">
        <div ng-if="!\$ctrl.playlists.length" class="jumbotron-note schedule-inspector-note">
          No playlists on this scene.
        </div>
        <button type="button" class="schedule-inspector-playlist" role="option"
          ng-repeat="collection in \$ctrl.playlists | filter:{name: \$ctrl.playlistSearch}"
          ng-class="{'is-selected': \$ctrl.draft.sceneCollectionId == collection.id}"
          ng-attr-aria-selected="{{\$ctrl.draft.sceneCollectionId == collection.id}}"
          ng-click="\$ctrl.selectPlaylist(collection)">
          <span class="jumbotron-dot schedule-inspector-dot" aria-hidden="true"
            ng-style="{ 'background-color': \$ctrl.colourOf(collection) }"></span>
          <span class="schedule-inspector-playlist-name">{{ collection.name }}</span>
          <i class="fas fa-check" aria-hidden="true" ng-if="\$ctrl.draft.sceneCollectionId == collection.id"></i>
        </button>
      </div>
      <p class="jumbotron-note schedule-inspector-note" ng-if="!\$ctrl.isNew">Pick another playlist to swap it. The times do not change.</p>
    </div>

    <div class="schedule-inspector-field">
      <label class="jumbotron-field-label schedule-inspector-label">Starts</label>
      <div class="schedule-inspector-when">
        <input type="date" class="form-control form-control-sm" ng-model="\$ctrl.field.startDate"
          ng-model-options="{ getterSetter: true }" aria-label="Start date">
        <input type="time" class="form-control form-control-sm" ng-model="\$ctrl.field.startTime"
          ng-model-options="{ getterSetter: true }" aria-label="Start time">
      </div>
    </div>

    <div class="schedule-inspector-field">
      <label class="jumbotron-field-label schedule-inspector-label">Ends</label>
      <div class="schedule-inspector-when">
        <input type="date" class="form-control form-control-sm" ng-model="\$ctrl.field.endDate"
          ng-model-options="{ getterSetter: true }" aria-label="End date">
        <input type="time" class="form-control form-control-sm" ng-model="\$ctrl.field.endTime"
          ng-model-options="{ getterSetter: true }" aria-label="End time">
      </div>
      <p class="jumbotron-note schedule-inspector-note" ng-if="\$ctrl.endReadBack">{{ \$ctrl.endReadBack }}</p>
    </div>

    <div class="schedule-inspector-field">
      <div class="jumbotron-field-label schedule-inspector-label" id="inspector-role-label">Role</div>
      <div class="schedule-inspector-roles" role="group" aria-labelledby="inspector-role-label">
        <button type="button" class="jumbotron-chip schedule-inspector-role"
          ng-class="{'is-selected': \$ctrl.role === 'basis'}"
          ng-attr-aria-pressed="{{ \$ctrl.role === 'basis' }}"
          title="The general playlist of the day." ng-click="\$ctrl.selectRole('basis')">Base</button>
        <button type="button" class="jumbotron-chip schedule-inspector-role"
          ng-class="{'is-selected': \$ctrl.role === 'takeover'}"
          ng-attr-aria-pressed="{{ \$ctrl.role === 'takeover' }}"
          title="A named act over the base." ng-click="\$ctrl.selectRole('takeover')">Takeover</button>
      </div>
      <p class="jumbotron-note schedule-inspector-note" ng-if="\$ctrl.roleNote">{{ \$ctrl.roleNote }}</p>
      <p class="jumbotron-note schedule-inspector-note" ng-if="\$ctrl.role === 'override'">
        The play button set this interval. It is on screen over everything else.
      </p>
      <p class="jumbotron-note schedule-inspector-note" ng-if="!\$ctrl.role && !\$ctrl.isNew">
        This interval is older than the roles. Select Base or Takeover, then save.
      </p>
      <p class="jumbotron-note schedule-inspector-note" ng-if="!\$ctrl.role && \$ctrl.isNew">
        The calendar does not show every interval at these times. The save selects the role from the overlaps.
      </p>
    </div>

    <div class="schedule-inspector-field" ng-if="\$ctrl.sharesStretch">
      <div class="jumbotron-field-label schedule-inspector-label">Shared stretch</div>
      <p class="jumbotron-note schedule-inspector-note">Overlaps {{ \$ctrl.peerNames }}</p>
    </div>

    <div class="schedule-inspector-field" ng-if="\$ctrl.screenShare">
      <div class="jumbotron-field-label schedule-inspector-label">On screen</div>
      <div class="jumbotron-note-box is-ok schedule-inspector-onscreen" ng-if="\$ctrl.promisesScreen">
        <i class="fas fa-arrow-up" aria-hidden="true"></i>
        <span>Takes the shared stretch when you save.</span>
      </div>
      <div class="jumbotron-note-box schedule-inspector-onscreen" ng-class="\$ctrl.screenShareNote.tone"
        ng-if="!\$ctrl.promisesScreen && \$ctrl.screenShareNote">
        <i class="fas" ng-class="\$ctrl.screenShareNote.icon" aria-hidden="true"></i>
        <span>{{ \$ctrl.screenShareText }}</span>
      </div>
    </div>

    <div class="schedule-inspector-tools" ng-if="!\$ctrl.isNew">
      <button type="button" class="btn btn-sm btn-outline-primary" ng-if="\$ctrl.offersStretch"
        ng-click="\$ctrl.takeStretch()" title="Wins the stretch it shares with {{ \$ctrl.peerNames }}.">
        <i class="fas fa-arrow-up" aria-hidden="true"></i>
        Put on screen
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.punchIn()"
        title="Opens a new takeover in the middle of this interval.">
        <i class="fas fa-bolt" aria-hidden="true"></i>
        Add a takeover
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-if="\$ctrl.draft.sceneCollectionId"
        ng-click="\$ctrl.openPlaylist()" title="Leaves the calendar and opens this playlist on the scene page.">
        <i class="fas fa-list" aria-hidden="true"></i>
        Edit playlist
      </button>
    </div>

    <div class="jumbotron-note-box is-bad schedule-inspector-live" ng-if="\$ctrl.coversNow"
      title="This interval covers the current moment. Saving can change what is on air right now.">
      <i class="fas fa-tower-broadcast" aria-hidden="true"></i>
      <span>On air now. A save takes effect at once.</span>
    </div>

    <div class="jumbotron-note-box is-warn schedule-inspector-blocked" ng-if="\$ctrl.blockedNote">{{ \$ctrl.blockedNote }}</div>

    <div class="schedule-inspector-actions">
      <button type="button" class="btn btn-sm" ng-click="\$ctrl.remove()"
        ng-class="\$ctrl.isNew ? 'btn-outline-secondary' : 'btn-discreet-danger'">
        {{ \$ctrl.isNew ? 'Cancel' : 'Delete' }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" ng-click="\$ctrl.save()"
        ng-disabled="\$ctrl.blockedBecause">
        {{ \$ctrl.isNew ? 'Create' : 'Save' }}
      </button>
    </div>
  </fieldset>
</div>
`;
// Exports
export default code;